import moment from 'moment';
import * as types from '../../constants/actionsType'

const initialState = {
  data: null,
  loader: true,
}
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SUCCESS_GET_SMTP_CONFIG:
      return {
        ...state,
        data: action.data.length > 0 ? action.data[0] : null,
        loader: false,
      }
    case types.FAILED_GET_SMTP_CONFIG:
      return {
        ...state,
        data: null,
        loader: false,
      }
    case types.LOADER_SMTP_APP:
      return {
        ...state,
        loader: true,
      }

    default:
      return state
  }
}
export default reducer